<template>
    <div class="container">
        <div class="improvement-item mb-1">
            <div class="d-flex align-items-start">
                <i class="fa fa-forward mr-3"></i>
                <div>
                    <h5 class="mb-1">Rápido e prático</h5>
                    <p class="text-muted mb-0">É igual fazer um pix, com a comodidade de agendar os próximos pagamentos.</p>
                </div>
            </div>
        </div>

        <div class="improvement-item mb-1">
            <div class="d-flex align-items-start">
                <i class="fa fa-plus mr-3"></i>
                <div>
                    <h5 class="mb-1">Ganhe tempo</h5>
                    <p class="text-muted mb-0">Sabemos que cada segundo é precioso, economize tempo com a gente.</p>
                </div>
            </div>
        </div>

        <div class="improvement-item mb-1">
            <div class="d-flex align-items-start">
                <i class="fa fa-calendar mr-3 mt-1"></i>
                <div>
                    <h5 class="mb-1">Sem atrasos</h5>
                    <p class="text-muted mb-0">Você não precisa mais decorar o dia de um compromisso financeiro, deixe isso conosco.</p>
                </div>
            </div>
        </div>
        <div class="improvement-item mb-2">
            <WhiteLabel>
                <a class="btn btn-transference w-100" @click="checkDevice()">
                    Seguir para Transferência
                </a>
          </WhiteLabel>
        </div>
    </div>
</template>
<script>

import WhiteLabel from '@/components/shared/WhiteLabel';

export default {
    name: 'NewTransferImprovementsModalSection',
    components: {
        WhiteLabel,
    },
    methods: {
        checkDevice() {
            this.$emit('check-device');
        },
    },
};
</script>

<style scoped lang="scss">
.improvement-item {
    padding: 0.5rem;
    border-radius: 0.375rem;
    h5 {
        font-size: 1.0rem;
        font-weight: 300;
        color: black;
    }
    p {
        font-size: 0.8rem;
        line-height: 1.4;
    }
    a {
        cursor: pointer;
    }
}
</style>
